import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  mobileButtonsBar: {
    gap: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0 auto',
    position: 'sticky',
    left: 0,
    right: 0,
    background: colors.neutral[100],
    padding: '2rem 5%',
    zIndex: 6,
    top: '6.4rem',
    marginBottom: '3rem',
  },
  filterButton: {
    '&:disabled': {
      backgroundColor: 'transparent',
      color: colors.neutral[600],
      textTransform: 'capitalize',
    },
  },
  title: {
    fontSize: '3.4rem',
    lineHeight: '4rem',
    textAlign: 'center',
  },
  productLineSwitcher: {
    margin: '4rem auto 6rem',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '25rem',
    gap: '2rem',
  },
  resetButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3rem',
    position: 'sticky',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 6,
    padding: '3rem 5%',
    background: colors.neutral[100],
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
    '& button': {
      width: '22rem',
      '@media(max-width: 524px)': {
        width: '50%',
        minWidth: 'auto',
      },
      '@media(max-width: 400px)': {
        justifyContent: 'center',
        '& > span': {
          display: 'none',
        },
      },
    },
  },
  proposalButton: {
    background: colors.neutral.white,
  },
  sidebarMobileView: {
    position: 'static',
    boxShadow: 'none',
    width: '100%',
    maxWidth: '100%',
    minHeight: '75vh',
    '& > div:first-child': {
      paddingBottom: '8.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      maxHeight: '100%',
      // hide productLine buttons section
      '& > div:nth-child(2)': {
        display: 'none',
      },
    },
    // hide close filter sidebar button (from lib)
    '&  > button': {
      display: 'none',
    },
  },
  browsingCard: {
    // Hide checkbox for compare plans in mobile view
    '& label': {
      display: 'none',
    },
    '& div[class^="cardFooter"]': {
      justifyContent: 'center',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
